import { HelpFeature } from '@/model/HelpModel';
import React, { useLayoutEffect } from 'react';
import { AddOperatorNoteModal, AlarmDetailsModal } from '../../components/alarms';
import { AlarmTable } from '../../components/alarms/AlarmsTable/AlarmTable';
import { getNewAlarmColorObject } from '../../components/alarms/helpers';
import { AlarmsIcon, HeaderTitleBar, HelpFactoryComponent, PreviewBadgeCredential } from '../../components/common';
import { EventTable } from '../../components/event';
import { User } from '../../model/AccountModel';
import { AlarmColorType } from '../../model/AlarmModel';
import { useStoreDispatch, useStoreSelector } from '../../store';
import { setAlarmColors, setShowAlarmCredentials, setShowAlarmDetails } from '../../store/alarm/actions';
import { selectShowAddOperatorNote, selectShowAlarmCredentials, selectShowAlarmDetails } from '../../store/alarm/selectors';
import styles from './alarms.module.scss';

const user: User = getUser();
const { showEventsOnAlarmsPage } = user;
const storedAlarmColors = getAlarmColors();
const topicId: string = 'AlarmViewerTab';

const AlarmsPage: React.FC = () => {
	const dispatch = useStoreDispatch();
	const showAlarmDetailsModal: boolean = useStoreSelector<boolean>(selectShowAlarmDetails);
	const { showCredentials, credentialsIds } = useStoreSelector(selectShowAlarmCredentials);
	const showAlarmAddOperatorNoteModal: boolean = useStoreSelector<boolean>(selectShowAddOperatorNote);

	useLayoutEffect(() => {
		dispatch(setAlarmColors(getNewAlarmColorObject(storedAlarmColors as unknown as Record<AlarmColorType, string>)));
	}, []);

	const handleOnHidePreviewBadgeModal = () => {
		dispatch(
			setShowAlarmCredentials({
				showCredentials: false,
				credentialsIds: [],
			})
		);
	};

	return (
		<div id='alarmsPageContainer'>
			<>
				<HeaderTitleBar
					title={_('AlarmViewer')}
					icon={<AlarmsIcon />}
					helpButton={<HelpFactoryComponent helpFeature={HelpFeature.Alarms} topicId={topicId} isLight size='medium' />}
				/>
				<div className={styles.alarmPageContainer}>
					<AlarmTable isAcknowledgedAlarmTable={false} topicId='ViewingAlarmInstructions' />
					<AlarmTable isAcknowledgedAlarmTable={true} topicId='AcknowledgingAlarms' />
				</div>
			</>
			{showAlarmDetailsModal && <AlarmDetailsModal onHideModal={() => dispatch(setShowAlarmDetails(undefined))} />}
			{showCredentials && <PreviewBadgeCredential onHideModal={handleOnHidePreviewBadgeModal} credentialsIds={credentialsIds} />}
			{showAlarmAddOperatorNoteModal && <AddOperatorNoteModal />}
			{showEventsOnAlarmsPage && <EventTable />}
		</div>
	);
};

export { AlarmsPage };
